import * as THREE from 'three'

import EditingArrow from '@glass-designer/objects/editingArrow'
import BaseObject from './baseObject'


// Editing Move Handle
// A single move handle object in the scene to display handles for the user interaction
// Displays either an single axis move or movement for all axies
export default class EditingMoveHandle extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.size = options.size || 22
    this.colour = options.colour || '#FFFFFF'
    this.hoverColour = options.hoverColour || '#808080'

    this.gridSnapDisabled = !!options.gridSnapDisabled

    this.axisMoveAll = options.axisMoveAll

    this.position = new THREE.Vector2(0, 0)
    this.moveLastPoint = new THREE.Vector2(0, 0)
    
    this.listenMouseEvents = true

    this.sceneObject = new THREE.Object3D()
    this.updateSceneObject()

    let arrowTex = editor.resources.arrowTextureMoveAll
    if(!this.axisMoveAll)
      arrowTex = editor.resources.arrowTextureMoveHorz

    this.moveArrow = new EditingArrow(this.editor, {
      colour: this.colour,
      hoverColour: this.hoverColour,
      arrowTexture: editor.resources.arrowTextureMoveAll
    })
    this.moveArrow.setRotation(0)
    this.moveArrow.setObjectEventListener(this)
    this.addChildObject(this.moveArrow)
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()
  }


  // Update the position of the handle
  setPosition(pos) {
    this.position.set(pos.x, pos.y)
    this.moveArrow.setPosition(pos)
  }

  // Get the position of the hand;e
  getPosition() {
    return this.position
  }

  // Update the angle of the move handle. To match axis with movement plane
  // In degrees
  setRotation(angle) {
    this.moveArrow.setRotation(angle)
  }


  /**
   * Build the initial drawing objects to display the editing line
   */
  updateSceneObject() {
    this.clearSceneObject()

  }


  clear() {
    
  }

  /**
   * Receive an object event from objects we're listening too
   */
  onReceiveObjectEvent(object, eventType, data) {
    if(object == this.moveArrow) {
      if(data.position)
        this.setPosition(data.position)

      // Bubble up events
      this.sendObjectEvent(eventType, data)
    }
  }

}
